export function NoAccess() {
  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-semibold md:text-3xl">No access</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Your account is not authorised to use the NuForce Admin Portal. If you believe this is in
          error, contact platform-ops@nuforce360.com.
        </p>
      </div>
    </main>
  );
}
